import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  AdministrationFormValues,
  AdministrationPageTexts,
} from '../../types/Administration';
import { ValidatedField } from '../../types/validation';
import { validateField } from '../../validation';

interface AdministrationState {
  searchTerm: string;
  form: AdministrationFormValues;
  pageTexts: AdministrationPageTexts | undefined;
}

const initialState: AdministrationState = {
  searchTerm: '',
  pageTexts: undefined,
  form: {
    firstname: {
      name: 'firstname',
      value: '',
      validationType: 'TEXT',
      required: true,
      isValid: false,
      isDirty: false,
    },
    lastname: {
      name: 'lastname',
      value: '',
      validationType: 'TEXT',
      required: true,
      isValid: false,
      isDirty: false,
    },
    telephone: {
      name: 'telephone',
      value: '',
      validationType: 'PHONENUMBER',
      required: true,
      isValid: false,
      isDirty: false,
    },
    mobilephone: {
      name: 'mobilephone',
      value: '',
      validationType: 'PHONENUMBER',
      required: true,
      isValid: false,
      isDirty: false,
    },
    email: {
      name: 'email',
      value: '',
      validationType: 'EMAIL',
      required: true,
      isValid: false,
      isDirty: false,
    },
  },
};

const administrationSlice = createSlice({
  name: 'administration',
  initialState,
  reducers: {
    setPageTexts(state, action: PayloadAction<AdministrationPageTexts>) {
      return { ...state, pageTexts: action.payload };
    },
    setSearchTerm(state, action: PayloadAction<string>) {
      state.searchTerm = action.payload.trim();
    },
    validateAndSetFormValueAdministration(
      state,
      action: PayloadAction<ValidatedField>
    ) {
      state.form = {
        ...state.form,
        [action.payload.name]: {
          ...state.form[action.payload.name as keyof AdministrationFormValues],
          ...action.payload,
          isValid: validateField({
            ...state.form[
              action.payload.name as keyof AdministrationFormValues
            ],
            ...action.payload,
          }),
        },
      };
    },
    clearFormFields(state) {
      return {
        ...state,
        form: {
          ...initialState.form,
        },
      };
    },
  },
});

export const {
  setSearchTerm,
  setPageTexts,
  validateAndSetFormValueAdministration,
} = administrationSlice.actions;

export default administrationSlice.reducer;
